// 10NewCase.js의 formData key 목록 기반
// label/type 없이 key만 배열로 작성

// 10NewCase.js의 formData key 목록 기반
// 기존 key는 모두 유지
// 한글 주석은 사용자가 전달한 항목 순서 기준
// 사용자가 별도로 전달하지 않은 추가 key는 12month_CPC 뒤에 배치

const formFieldKeys = [
  "pt_name", // 환자이름
  "pt_number", // 환자번호
  "birth", // 생년월일
  "age", // 나이
  "sex", // 성별
  "height", // 키
  "weight", // 몸무게
  "waist_circumference", // 허리 둘레
  "hip_circumference", // 엉덩이 둘레
  "ED_arrival_time", // 응급실 도착시각
  "transfer", // 타 병원에서 전원 옴
  "arrest_location", // 심정지 발생장소
  "Baseline_CPC", // 심정지 발생 전 CPC
  "witness", // 심정지 목격
  "arrest_time", // 심정지 발견 시각
  "LNT_time", // 마지막 생존 확인 시각
  "witness_by", // 심정지 발견 목격자/발견자
  "Immediate_CPR", // 즉시 흉부압박 시행여부
  "Bystander_CPR", // 목격자/발견자 흉부압박
  "Bystander_CPR_time", // 목격자/발견자 흉부압박 시각
  "Bystander_AED", // 목격자/발견자 AED 사용
  "EMS_call_time", // EMS 신고 시각
  "EMS_arrive_time", // EMS 현장 도착 시각
  "X2nd_arrive_time", // 2번째 구급차 도착 시각
  "EMS_Departure_time", // EMS 현장 이탈 시각(병원으로 출발 시각)
  "EMS_CPR", // 구급대원 흉부압박
  "Mech_CPR", // Mechanical CPR device 적용
  "EMS_1st_rhythm", // 첫 리듬
  "EMS_1st_rhythm_time", // 첫 리듬 시각
  "EMS_1st_rhythm_by", // 첫 리듬 관찰자
  "EMS_shock", // 구급대원 제세동
  "EMS_shock_energy", // 구급대원 첫 제세동 에너지(J)
  "EMS_shock_number", // 구급대원 제세동 횟수
  "EMS_airway", // 구급대원 기관삽관
  "advanced_airway_time", // 전문기도유지기 삽입시각
  "EMS_iv", // 구급대원 정맥로 확보
  "EMS_fluid", // 응급실 내원 전 수액 투여량(ml)
  "EMS_epi", // 구급대원 에피네프린 투여
  "EMS_epi_time", // 구급대원 에피네프린 투여 시각
  "EMS_amio", // 구급대원 아미오다론 투여
  "EMS_amio_time", // 구급대원 아미오다론 투여 시각
  "Pre_ROSC", // 병원 도착 전 자발순환회복
  "Pre_ROSC_time", // 병원 도착 전 자발순환 회복 시각
  "Pre_stop_CPR", // 병원 도착 전 심폐소생술 중단
  "Pre_stop_CPR_cause", // 병원 도착 전 심폐소생술 중단 시각
  "ED_arrival_time_two", // 응급실 도착 시각
  "Transport", // 병원 이송 수단
  "Resusci_room_time", // 소생실/중환구역 입실시각
  "HTN", // 고혈압
  "DM", // 당뇨
  "dyslipidemia", // 고지혈증
  "LC", // 간경화
  "CHF", // 심부전
  "stroke", // 뇌졸중
  "PM", // Pacemaker
  "ICD", // ICD
  "CKD", // 신부전
  "malig", // 암/혈액암
  "ED_CPR", // 응급실 소생술 시도
  "ED_CPR_cause", // 소생술 미시행 이유
  "ED_CPR_datetime", // 응급실 흉부압박 시작시각
  "ED_rhythm", // 응급실에서 첫 리듬
  "ED_defib", // 응급실 제세동 시도
  "ED_defib_datetime", // 응급실 첫 제세동 시각
  "ED_intubation", // 응급실 기관내 삽입
  "ED_intubation_datetime", // 응급실 기관내 삽입 시각
  "ED_epi", // 응급실 에피네프린 투여
  "ED_epi_datetime", // 응급실 에피네프린 투여 시각
  "ED_amio", // 응급실 아미오다론 투여
  "ED_amio_datetime", // 응급실 아미오다론 투여 시각
  "ED_central", // CPR 중 C-line 삽입
  "ED_CVC_insert_datetime", // CPR 중 C-line 삽입 시각
  "ED_Aline", // CPR 중 A-line 삽입
  "ED_Aline_insert_datetime", // CPR 중 A-line 삽입 시각
  "NIRS", // NIRS
  "REBOA", // REBOA
  "ECPR", // ECPR
  "pump_on_time", // Pump on time
  "ROSB", // ROSB
  "ROSB_time", // ROSB time
  "ED_stop_datetime", // 심폐소생술 중단 시각
  "ED_fluid", // 심폐소생술 중 수액 투여량(ml)
  "ED_stop_cause", // 심폐소생술 중단 이유
  "Cause_arrest", // 심정지 원인
  "Cause_medical", // 심정지 비심인성 원인
  "Cause_trauma", // 심정지 외상성 원인(Blunt/Penetrating)
  "Cause_asphyxia", // 심정지 질식 원인
  "ROSC", // ROSC 여부, 장소 관계 없음
  "ED_ROSC", // ROSC, 응급실에서만
  "ED_nonsust_ROSC_datetime", // Not sustained ROSC
  "ED_sust_ROSC_datetime", // Sustained ROSC
  "ROSC1_Re_arrest", // 1st re-arrest 여부
  "ROSC#1 - Re-arrest_datetime", // 1st re-arrest time
  "1st_rearrest_ROSC", // 1st re-arrest ROSC
  "1st_rearrest_susROSC_datetime", // 1st re-arrest Sustained ROSC time
  "ROSC2_Re_arrest", // 2st re-arrest 여부
  "ROSC#2 - Re-arrest_datetime", // 2st re-arrest time
  "2nd_rearrest_ROSC", // 2st re-arrest ROSC
  "2nd_rearrest_susROSC_datetime", // 2st re-arrest Sustained ROSC time
  "ROSC3_Re_arrest", // 3st re-arrest 여부
  "ROSC#3 - Re-arrest_datetime", // 3st re-arrest time
  "3rd_rearrest_ROSC", // 3st re-arrest ROSC
  "3rd_rearrest_susROSC_datetime", // 3st re-arrest Sustained ROSC time
  "ED_ROSC_ECG", // ROSC 심전도
  "ED_disposition", // 결과
  "Dead", // 사망
  "Admission", // 입원
  "NCV_em", // NCV 응급용 선별검사
  "NCV", // NCV 정규검사
  "admission_memo", // 초진 기록지
  "discharge_memo", // 응급실 퇴실 기록지
  "DNR", // DNR 작성여부
  "TTM", // TTM 시행
  "TTM_temp", // TTM 초기 설정 온도(°C)
  "TTM_reason", // TTM 미사유
  "ECMO", // CPR 후 ECMO 시행
  "CRRT", // CRRT 시행
  "Discharge_datetime", // 퇴원시각
  "Discharge_Type", // 퇴원형태
  "Discharge_Note", // 퇴원기록지
  "Discarge_CPC", // Discharge CPC
  "1month_CPC", // 1month CPC
  "3month_CPC", // 3month CPC
  "6month_CPC", // 6month CPC
  "12month_CPC", // 12month CPC

  // 아래는 사용자가 처음 전달한 한글 목록에 없었던 추가 key들
  "arrest_location_others", // 심정지 발생장소 기타
  "EMS_CPR_time", // 구급대원 흉부압박 시각
  "EMS_shock_time", // 구급대원 첫 제세동 시각
  "EMS_shock_success", // 구급대원 제세동 성공 여부
  "ED_ROSC_ECG_others", // ROSC 심전도 기타
  "TTM_others_text", // TTM 미사유 기타

  "CPR_pupil", // CPR 중 동공 평가 여부
  "CPR_pupil_size_rt", // CPR 중 우측 동공 크기
  "CPR_pupil_size_lt", // CPR 중 좌측 동공 크기
  "CPR_pupil_light_rt", // CPR 중 우측 대광반사
  "CPR_pupil_light_lt", // CPR 중 좌측 대광반사

  "ROSC_pupil", // ROSC 직후 동공 평가 여부
  "ROSC_pupil_size_rt", // ROSC 직후 우측 동공 크기
  "ROSC_pupil_size_lt", // ROSC 직후 좌측 동공 크기
  "ROSC_pupil_light_rt", // ROSC 직후 우측 대광반사
  "ROSC_pupil_light_lt", // ROSC 직후 좌측 대광반사

  "12th_pupil", // 12시간 동공 평가 여부
  "12th_pupil_size_rt", // 12시간 우측 동공 크기
  "12th_pupil_size_lt", // 12시간 좌측 동공 크기
  "12th_pupil_light_rt", // 12시간 우측 대광반사
  "12th_pupil_light_lt", // 12시간 좌측 대광반사

  "24th_pupil", // 24시간 동공 평가 여부
  "24th_pupil_size_rt", // 24시간 우측 동공 크기
  "24th_pupil_size_lt", // 24시간 좌측 동공 크기
  "24th_pupil_light_rt", // 24시간 우측 대광반사
  "24th_pupil_light_lt", // 24시간 좌측 대광반사

  "36th_pupil", // 36시간 동공 평가 여부
  "36th_pupil_size_rt", // 36시간 우측 동공 크기
  "36th_pupil_size_lt", // 36시간 좌측 동공 크기
  "36th_pupil_light_rt", // 36시간 우측 대광반사
  "36th_pupil_light_lt", // 36시간 좌측 대광반사

  "48th_pupil", // 48시간 동공 평가 여부
  "48th_pupil_size_rt", // 48시간 우측 동공 크기
  "48th_pupil_size_lt", // 48시간 좌측 동공 크기
  "48th_pupil_light_rt", // 48시간 우측 대광반사
  "48th_pupil_light_lt", // 48시간 좌측 대광반사

  "60th_pupil", // 60시간 동공 평가 여부
  "60th_pupil_size_rt", // 60시간 우측 동공 크기
  "60th_pupil_size_lt", // 60시간 좌측 동공 크기
  "60th_pupil_light_rt", // 60시간 우측 대광반사
  "60th_pupil_light_lt", // 60시간 좌측 대광반사

  "72th_pupil", // 72시간 동공 평가 여부
  "72th_pupil_size_rt", // 72시간 우측 동공 크기
  "72th_pupil_size_lt", // 72시간 좌측 동공 크기
  "72th_pupil_light_rt", // 72시간 우측 대광반사
  "72th_pupil_light_lt", // 72시간 좌측 대광반사

  "Arrest_site", // 심정지 부위/현장 관련 추가 변수
  "ED_site_specific", // 응급실 위치 관련 추가 변수
  "Witness_by_medical_staff", // 의료진 목격 여부
  "category", // 분류
  "admissionDate", // 입원일
  "dischargeDate", // 퇴원일
  "condition", // 상태
  "mainComplaint", // 주호소
  "pastHistory", // 과거력
  "medicationHistory", // 복약력
  "allergies", // 알레르기
  "isFastTrack", // 패스트트랙 여부
  "assignedDoctor", // 담당의
  "priority", // 우선순위
  "notes", // 비고
  "attachments", // 첨부파일

  "response_time", // 신고-도착 반응시간
  "scene_time", // 현장 체류시간
  "transport_time", // 이송시간

  "NSE_Inital_ROSC", // Initial ROSC 후 NSE
  "NSE_24h", // 24시간 NSE
  "NSE_36h", // 36시간 NSE
  "NSE_48h", // 48시간 NSE
  "NSE_72h", // 72시간 NSE

  "NPI_Rt_arrest", // CPR 중 우측 NPI
  "NPI_Lt_arrest", // CPR 중 좌측 NPI
  "Size_Rt_arrest", // CPR 중 우측 동공 크기
  "Size_Lt_arrest", // CPR 중 좌측 동공 크기
  "Min_Rt_arrest", // CPR 중 우측 최소크기
  "Min_Lt_arrest", // CPR 중 좌측 최소크기
  "Ch_Rt_arrest", // CPR 중 우측 변화율
  "Ch_Lt_arrest", // CPR 중 좌측 변화율
  "CV_Rt_arrest", // CPR 중 우측 CV
  "CV_Lt_arrest", // CPR 중 좌측 CV
  "MCV_Rt_arrest", // CPR 중 우측 MCV
  "MCV_Lt_arrest", // CPR 중 좌측 MCV
  "LAT_Rt_arrest", // CPR 중 우측 LAT
  "LAT_Lt_arrest", // CPR 중 좌측 LAT
  "DV_Rt_arrest", // CPR 중 우측 DV
  "DV_Lt_arrest", // CPR 중 좌측 DV

  "NPI_Rt_ROSC", // ROSC 직후 우측 NPI
  "NPI_Lt_ROSC", // ROSC 직후 좌측 NPI
  "Size_Rt_ROSC", // ROSC 직후 우측 동공 크기
  "Size_Lt_ROSC", // ROSC 직후 좌측 동공 크기
  "Min_Rt_ROSC", // ROSC 직후 우측 최소크기
  "Min_Lt_ROSC", // ROSC 직후 좌측 최소크기
  "Ch_Rt_ROSC", // ROSC 직후 우측 변화율
  "Ch_Lt_ROSC", // ROSC 직후 좌측 변화율
  "CV_Rt_ROSC", // ROSC 직후 우측 CV
  "CV_Lt_ROSC", // ROSC 직후 좌측 CV
  "MCV_Rt_ROSC", // ROSC 직후 우측 MCV
  "MCV_Lt_ROSC", // ROSC 직후 좌측 MCV
  "LAT_Rt_ROSC", // ROSC 직후 우측 LAT
  "LAT_Lt_ROSC", // ROSC 직후 좌측 LAT
  "DV_Rt_ROSC", // ROSC 직후 우측 DV
  "DV_Lt_ROSC", // ROSC 직후 좌측 DV

  "NPI_Rt_12hrs", // 12시간 우측 NPI
  "NPI_Lt_12hrs", // 12시간 좌측 NPI
  "Size_Rt_12hrs", // 12시간 우측 동공 크기
  "Size_Lt_12hrs", // 12시간 좌측 동공 크기
  "Min_Rt_12hrs", // 12시간 우측 최소크기
  "Min_Lt_12hrs", // 12시간 좌측 최소크기
  "Ch_Rt_12hrs", // 12시간 우측 변화율
  "Ch_Lt_12hrs", // 12시간 좌측 변화율
  "CV_Rt_12hrs", // 12시간 우측 CV
  "CV_Lt_12hrs", // 12시간 좌측 CV
  "MCV_Rt_12hrs", // 12시간 우측 MCV
  "MCV_Lt_12hrs", // 12시간 좌측 MCV
  "LAT_Rt_12hrs", // 12시간 우측 LAT
  "LAT_Lt_12hrs", // 12시간 좌측 LAT
  "DV_Rt_12hrs", // 12시간 우측 DV
  "DV_Lt_12hrs", // 12시간 좌측 DV

  "caseId", // 케이스 ID
];

// 260413 기준 old 코드
// const formFieldKeys = [
//   "pt_number",
//   "pt_name",
//   "age",
//   "sex",
//   "birth",
//   "height",
//   "weight",
//   "waist_circumference",
//   "hip_circumference",
//   "ED_arrival_time",
//   "transfer",
//   "arrest_location",
//   "arrest_location_others",
//   "Baseline_CPC",
//   "witness",
//   "arrest_time",
//   "LNT_time",
//   "witness_by",
//   "Immediate_CPR",
//   "Bystander_CPR",
//   "Bystander_AED",
//   "Bystander_CPR_time",
//   "EMS_call_time",
//   "EMS_arrive_time",
//   "X2nd_arrive_time",
//   "EMS_Departure_time",
//   "EMS_CPR",
//   "EMS_CPR_time",
//   "Mech_CPR",
//   "EMS_1st_rhythm",
//   "EMS_1st_rhythm_time",
//   "EMS_1st_rhythm_by",
//   "EMS_shock",
//   "EMS_shock_time",
//   "EMS_shock_success",
//   "EMS_shock_energy",
//   "EMS_shock_number",
//   "EMS_airway",
//   "advanced_airway_time",
//   "EMS_iv",
//   "EMS_fluid",
//   "EMS_epi",
//   "EMS_epi_time",
//   "EMS_amio",
//   "EMS_amio_time",
//   "Pre_ROSC",
//   "Pre_ROSC_time",
//   "Pre_stop_CPR",
//   "Pre_stop_CPR_cause",
//   "ED_arrival_time_two",
//   "Transport",
//   "Resusci_room_time",
//   "HTN",
//   "DM",
//   "dyslipidemia",
//   "LC",
//   "CHF",
//   "stroke",
//   "PM",
//   "ICD",
//   "CKD",
//   "malig",
//   "ED_CPR",
//   "ED_CPR_cause",
//   "ED_CPR_datetime",
//   "ED_rhythm",
//   "ED_defib",
//   "ED_defib_datetime",
//   "ED_intubation",
//   "ED_intubation_datetime",
//   "ED_epi",
//   "ED_epi_datetime",
//   "ED_amio",
//   "ED_amio_datetime",
//   "ED_central",
//   "ED_CVC_insert_datetime",
//   "ED_Aline",
//   "ED_Aline_insert_datetime",
//   "NIRS",
//   "REBOA",
//   "ECPR",
//   "pump_on_time",
//   "ROSB",
//   "ROSB_time",
//   "ED_stop_datetime",
//   "ED_fluid",
//   "ED_stop_cause",
//   "Cause_arrest",
//   "Cause_medical",
//   "Cause_trauma",
//   "Cause_asphyxia",
//   "ROSC",
//   "ED_ROSC",
//   "ED_nonsust_ROSC_datetime",
//   "ED_sust_ROSC_datetime",
//   "ROSC1_Re_arrest",
//   "ROSC#1 - Re-arrest_datetime",
//   "1st_rearrest_ROSC",
//   "1st_rearrest_susROSC_datetime",
//   "ROSC2_Re_arrest",
//   "ROSC#2 - Re-arrest_datetime",
//   "2nd_rearrest_ROSC",
//   "2nd_rearrest_susROSC_datetime",
//   "ROSC3_Re_arrest",
//   "ROSC#3 - Re-arrest_datetime",
//   "3rd_rearrest_ROSC",
//   "3rd_rearrest_susROSC_datetime",
//   "ED_ROSC_ECG",
//   "ED_ROSC_ECG_others",
//   "ED_disposition",
//   "Dead",
//   "Admission",
//   "NCV_em",
//   "NCV",
//   "admission_memo",
//   "discharge_memo",
//   "TTM",
//   "TTM_reason",
//   "TTM_others_text",
//   "TTM_tem",
//   "CPR_pupil",
//   "CPR_pupil_size_rt",
//   "CPR_pupil_size_lt",
//   "CPR_pupil_light_rt",
//   "CPR_pupil_light_lt",
//   "ROSC_pupil",
//   "ROSC_pupil_size_rt",
//   "ROSC_pupil_size_lt",
//   "ROSC_pupil_light_rt",
//   "ROSC_pupil_light_lt",
//   "12th_pupil",
//   "12th_pupil_size_rt",
//   "12th_pupil_size_lt",
//   "12th_pupil_light_rt",
//   "12th_pupil_light_lt",
//   "24th_pupil",
//   "24th_pupil_size_rt",
//   "24th_pupil_size_lt",
//   "24th_pupil_light_rt",
//   "24th_pupil_light_lt",
//   "36th_pupil",
//   "36th_pupil_size_rt",
//   "36th_pupil_size_lt",
//   "36th_pupil_light_rt",
//   "36th_pupil_light_lt",
//   "48th_pupil",
//   "48th_pupil_size_rt",
//   "48th_pupil_size_lt",
//   "48th_pupil_light_rt",
//   "48th_pupil_light_lt",
//   "60th_pupil",
//   "60th_pupil_size_rt",
//   "60th_pupil_size_lt",
//   "60th_pupil_light_rt",
//   "60th_pupil_light_lt",
//   "72th_pupil",
//   "72th_pupil_size_rt",
//   "72th_pupil_size_lt",
//   "72th_pupil_light_rt",
//   "72th_pupil_light_lt",
//   "Arrest_site",
//   "ED_site_specific",
//   "Witness_by_medical_staff",
//   "category",
//   "admissionDate",
//   "dischargeDate",
//   "condition",
//   "mainComplaint",
//   "pastHistory",
//   "medicationHistory",
//   "allergies",
//   "isFastTrack",
//   "assignedDoctor",
//   "priority",
//   "notes",
//   "attachments",
//   "response_time",
//   "scene_time",
//   "transport_time",
//   "DNR",
//   "TTM_temp",
//   "ECMO",
//   "CRRT",
//   "Discharge_datetime",
//   "Discharge_Type",
//   "Discharge_Note",
//   "Discarge_CPC",
//   "1month_CPC",
//   "3month_CPC",
//   "6month_CPC",
//   "12month_CPC",
//   "NSE_Inital_ROSC",
//   "NSE_24h",
//   "NSE_36h",
//   "NSE_48h",
//   "NSE_72h",
//   "NPI_Rt_arrest",
//   "NPI_Lt_arrest",
//   "Size_Rt_arrest",
//   "Size_Lt_arrest",
//   "Min_Rt_arrest",
//   "Min_Lt_arrest",
//   "Ch_Rt_arrest",
//   "Ch_Lt_arrest",
//   "CV_Rt_arrest",
//   "CV_Lt_arrest",
//   "MCV_Rt_arrest",
//   "MCV_Lt_arrest",
//   "LAT_Rt_arrest",
//   "LAT_Lt_arrest",
//   "DV_Rt_arrest",
//   "DV_Lt_arrest",
//   "NPI_Rt_ROSC",
//   "NPI_Lt_ROSC",
//   "Size_Rt_ROSC",
//   "Size_Lt_ROSC",
//   "Min_Rt_ROSC",
//   "Min_Lt_ROSC",
//   "Ch_Rt_ROSC",
//   "Ch_Lt_ROSC",
//   "CV_Rt_ROSC",
//   "CV_Lt_ROSC",
//   "MCV_Rt_ROSC",
//   "MCV_Lt_ROSC",
//   "LAT_Rt_ROSC",
//   "LAT_Lt_ROSC",
//   "DV_Rt_ROSC",
//   "DV_Lt_ROSC",
//   "NPI_Rt_12hrs",
//   "NPI_Lt_12hrs",
//   "Size_Rt_12hrs",
//   "Size_Lt_12hrs",
//   "Min_Rt_12hrs",
//   "Min_Lt_12hrs",
//   "Ch_Rt_12hrs",
//   "Ch_Lt_12hrs",
//   "CV_Rt_12hrs",
//   "CV_Lt_12hrs",
//   "MCV_Rt_12hrs",
//   "MCV_Lt_12hrs",
//   "LAT_Rt_12hrs",
//   "LAT_Lt_12hrs",
//   "DV_Rt_12hrs",
//   "DV_Lt_12hrs",
//   "caseId",
// ];

export default formFieldKeys;

// 향후 label, type 정보를 채워 넣을 수 있도록 기본 객체 배열도 함께 export
// 현재는 label은 id와 동일, type은 'text'로 기본 설정해 둔다.
export const formFieldDefs = [
  {
    id: "pt_name",
    label: "환자이름",
    type: "text",
  },
  {
    id: "pt_number",
    label: "환자번호",
    type: "text",
  },
  {
    id: "birth",
    label: "생년월일",
    type: "date",
  },
  {
    id: "age",
    label: "나이",
    type: "text",
    conditions: "생년월일이 입력되면 자동 계산됨",
  },
  {
    id: "sex",
    label: "성별",
    type: "radio",
    options: [
      { label: "남성", value: "male" },
      { label: "여성", value: "female" },
    ],
  },
  {
    id: "height",
    label: "키",
    type: "text",
    unit: "cm",
  },
  {
    id: "weight",
    label: "몸무게",
    type: "text",
    unit: "kg",
  },
  {
    id: "waist_circumference",
    label: "허리 둘레",
    type: "text",
    unit: "cm",
  },
  {
    id: "hip_circumference",
    label: "엉덩이 둘레",
    type: "text",
    unit: "cm",
  },
  {
    id: "ED_arrival_time",
    label: "응급실 도착시각",
    type: "datetime-local",
  },
  {
    id: "transfer",
    label: "타 병원에서 전원 옴",
    type: "radio",
    options: [
      { label: "예", value: "yes" },
      { label: "아니오", value: "no" },
    ],
  },
  {
    id: "arrest_location",
    label: "심정지 발생장소",
    type: "radio",
    options: [
      { label: "집", value: "집" },
      { label: "직장/학교", value: "직장/학교" },
      { label: "거리/도로", value: "거리/도로" },
      { label: "공공시설", value: "공공시설" },
      { label: "요양시설", value: "요양시설" },
      { label: "교육시설", value: "교육시설" },
      { label: "스포츠/레크레이션", value: "스포츠/레크레이션" },
      { label: "병원 이송 중", value: "병원 이송 중" },
      { label: "타 병원", value: "타 병원" },
      { label: "기타", value: "기타" },
      { label: "미상", value: "미상" },
    ],
  },
  {
    id: "arrest_location_others",
    label: "심정지 발생장소(기타)",
    type: "text",
    conditions: 'arrest_location === "기타"',
  },
  {
    id: "Baseline_CPC",
    label: "심정지 발생 전 CPC",
    type: "radio",
    options: [
      { label: "CPC1", value: "CPC1" },
      { label: "CPC2", value: "CPC2" },
      { label: "CPC3", value: "CPC3" },
      { label: "CPC4", value: "CPC4" },
      { label: "CPC5", value: "CPC5" },
    ],
  },
  {
    id: "witness",
    label: "심정지 목격",
    type: "radio",
    options: [
      { label: "목격됨 (witnessed)", value: "목격됨 (witnessed)" },
      {
        label: "목격되지 않음 (unwitnessed)",
        value: "목격되지 않음 (unwitnessed)",
      },
    ],
  },
  {
    id: "arrest_time",
    label: "심정지 발견 시각",
    type: "datetime-local",
  },
  {
    id: "LNT_time",
    label: "마지막 생존 확인 시각",
    type: "datetime-local",
  },
  {
    id: "witness_by",
    label: "심정지 발견 목격자/발견자",
    type: "radio",
    options: [
      { label: "가족", value: "가족" },
      { label: "행인", value: "행인" },
      { label: "근무중인 구급대원", value: "구급대원" },
      { label: "근무중인 의료인", value: "의료인(구급대원 제외)" },
    ],
    conditions: 'witness === "목격됨 (witnessed)"',
  },
  {
    id: "Immediate_CPR",
    label: "즉시 흉부압박 시행여부",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "Bystander_CPR",
    label: "목격자/발견자 흉부압박",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
    conditions: [
      'witness === "목격됨 (witnessed)"',
      { or: ['witness_by === "가족"', 'witness_by === "행인"'] },
    ],
  },
  {
    id: "Bystander_AED",
    label: "목격자/발견자 AED 사용",
    type: "radio",
    options: [
      { label: "아니오", value: "아니오" },
      {
        label: "사용하였으나 shock 권고하지 않음",
        value: "사용하였으나 shock 권고하지 않음",
      },
      {
        label: "사용하였으며 shock 권고함",
        value: "사용하였으며 shock 권고함",
      },
    ],
    conditions: [
      'witness === "목격됨 (witnessed)"',
      { or: ['witness_by === "가족"', 'witness_by === "행인"'] },
    ],
  },
  {
    id: "Bystander_CPR_time",
    label: "목격자/발견자 흉부압박 시각",
    type: "datetime-local",
    conditions: [
      'Bystander_CPR === "예"',
      'witness === "목격됨 (witnessed)"',
      { or: ['witness_by === "가족"', 'witness_by === "행인"'] },
    ],
  },
  {
    id: "EMS_call_time",
    label: "EMS 신고 시각",
    type: "datetime-local",
  },
  {
    id: "EMS_arrive_time",
    label: "EMS 현장 도착 시각",
    type: "datetime-local",
  },
  {
    id: "X2nd_arrive_time",
    label: "2번째 구급차 도착 시각",
    type: "datetime-local",
  },
  {
    id: "EMS_Departure_time",
    label: "EMS 현장 이탈 시각 (병원으로 출발 시각)",
    type: "datetime-local",
  },
  {
    id: "EMS_CPR",
    label: "구급대원 흉부압박",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "EMS_CPR_time",
    label: "구급대원 흉부압박 시각",
    type: "datetime-local",
    conditions: 'EMS_CPR === "예"',
  },
  {
    id: "Mech_CPR",
    label: "Mechanical CPR device 적용",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "EMS_1st_rhythm",
    label: "첫 리듬",
    type: "radio",
    options: [
      { label: "VF", value: "VF" },
      { label: "pVT", value: "pVT" },
      { label: "PEA", value: "PEA" },
      { label: "asystole", value: "asystole" },
      { label: "shockable", value: "shockable" },
      { label: "non-shockable", value: "non-shockable" },
      { label: "not obtained", value: "not obtained" },
      { label: "맥박 촉지됨", value: "맥박 촉지됨" },
    ],
  },
  {
    id: "EMS_1st_rhythm_time",
    label: "첫 리듬 시각",
    type: "datetime-local",
  },
  {
    id: "EMS_1st_rhythm_by",
    label: "첫 리듬 관찰자",
    type: "radio",
    options: [
      { label: "병원의료진", value: "병원의료진" },
      { label: "구급대원", value: "구급대원" },
      { label: "기타", value: "기타" },
    ],
  },
  {
    id: "EMS_shock",
    label: "구급대원 제세동",
    type: "radio",
    options: [
      { label: "제세동 시행함", value: "제세동 시행함" },
      {
        label: "심전도 분석결과 shock 권고되지 않음",
        value: "심전도 분석결과 shock 권고되지 않음",
      },
      {
        label: "심전도 분석 시행하지 않음",
        value: "심전도 분석 시행하지 않음",
      },
    ],
  },
  {
    id: "EMS_shock_time",
    label: "구급대원 첫 제세동 시각",
    type: "datetime-local",
    conditions: 'EMS_shock === "제세동 시행함"',
  },
  {
    id: "EMS_shock_success",
    label: "구급대원 제세동 성공 여부",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
    conditions: 'EMS_shock === "제세동 시행함"',
  },
  {
    id: "EMS_shock_energy",
    label: "구급대원 첫 제세동 에너지",
    type: "text",
    unit: "J",
  },
  {
    id: "EMS_shock_number",
    label: "구급대원 제세동 횟수",
    type: "text",
    unit: "회",
  },
  {
    id: "EMS_airway",
    label: "구급대원 기관삽관",
    type: "radio",
    options: [
      { label: "기관삽관", value: "기관삽관" },
      { label: "대체 기도기 사용", value: "대체 기도기 사용" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "advanced_airway_time",
    label: "전문기도유지기 삽입 시각",
    type: "datetime-local",
    conditions: {
      or: ['EMS_airway === "기관삽관"', 'EMS_airway === "대체 기도기 사용"'],
    },
  },

  // 기존 배열에 이어서 계속됨
  {
    id: "ED_arrival_time_two",
    label: "응급실 도착 시각",
    type: "datetime-local",
  },
  {
    id: "Transport",
    label: "병원 이송 수단",
    type: "radio",
    options: [
      { label: "119", value: "119" },
      { label: "사설구급차", value: "사설구급차" },
      { label: "병원구급차", value: "병원구급차" },
      { label: "경찰차", value: "경찰차" },
      { label: "택시", value: "택시" },
      { label: "기타", value: "기타" },
      { label: "미상", value: "미상" },
    ],
  },
  {
    id: "Resusci_room_time",
    label: "소생실/중환구역 입실 시각",
    type: "datetime-local",
  },
  {
    id: "HTN",
    label: "고혈압",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "DM",
    label: "당뇨",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "dyslipidemia",
    label: "고지혈증",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "LC",
    label: "간경화",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "CHF",
    label: "심부전",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "stroke",
    label: "뇌졸중",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "PM",
    label: "Pacemaker",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "ICD",
    label: "ICD",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "CKD",
    label: "신부전",
    type: "radio",
    options: [
      { label: "예(투석O)", value: "예(투석O)" },
      { label: "예(투석X)", value: "예(투석X)" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "malig",
    label: "암/혈액암",
    type: "radio",
    options: [
      { label: "예(완치)", value: "예(완치)" },
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "ED_CPR",
    label: "응급실 소생술 시도",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "ED_CPR_cause",
    label: "소생술 미시행 이유",
    type: "radio",
    options: [
      { label: "도착 시 ROSC", value: "도착 시 ROSC" },
      { label: "소생가능성희박", value: "소생가능성희박" },
      { label: "DNR", value: "DNR" },
    ],
  },
  {
    id: "ED_CPR_datetime",
    label: "응급실 흉부압박 시작 시각",
    type: "datetime-local",
  },
  {
    id: "ED_rhythm",
    label: "응급실에서 첫 리듬",
    type: "radio",
    options: [
      { label: "ROSC상태", value: "ROSC상태" },
      { label: "VF", value: "VF" },
      { label: "pVT", value: "pVT" },
      { label: "PEA", value: "PEA" },
      { label: "asystole", value: "asystole" },
      { label: "shockable", value: "shockable" },
      { label: "non-shockable", value: "non-shockable" },
    ],
  },
  {
    id: "ED_defib",
    label: "응급실 제세동시도",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "ED_defib_datetime",
    label: "응급실 첫 제세동 시각",
    type: "datetime-local",
    conditions: 'ED_defib === "예"',
  },
  {
    id: "ED_intubation",
    label: "응급실 기관내 삽관",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "ED_intubation_datetime",
    label: "응급실 기관내 삽관 시각",
    type: "datetime-local",
    conditions: 'ED_intubation === "예"',
  },
  {
    id: "ED_epi",
    label: "응급실 에피네프린 투여",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "ED_epi_datetime",
    label: "응급실 에피네프린 투여 시각",
    type: "datetime-local",
    conditions: 'ED_epi === "예"',
  },
  {
    id: "ED_amio",
    label: "응급실 아미오다론 투여",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "ED_amio_datetime",
    label: "응급실 아미오다론 투여 시각",
    type: "datetime-local",
    conditions: 'ED_amio === "예"',
  },
  {
    id: "ED_central",
    label: "CPR 중 C-line 삽입",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "ED_CVC_insert_datetime",
    label: "CPR 중 C-line 삽입 시각",
    type: "datetime-local",
    conditions: 'ED_central === "예"',
  },
  {
    id: "ED_Aline",
    label: "CPR 중 A-line 삽입",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "ED_Aline_insert_datetime",
    label: "CPR 중 A-line 삽입 시각",
    type: "datetime-local",
    conditions: 'ED_Aline === "예"',
  },
  {
    id: "NIRS",
    label: "NIRS",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "REBOA",
    label: "REBOA",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "ECPR",
    label: "ECPR",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "pump_on_time",
    label: "Pump on time",
    type: "datetime-local",
    conditions: 'ECPR === "예"',
  },
  {
    id: "ROSB",
    label: "ROSB",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
    conditions: 'ECPR === "예"',
  },
  {
    id: "ROSB_time",
    label: "ROSB time",
    type: "datetime-local",
    conditions: 'ROSB === "예"',
  },
  {
    id: "ED_stop_datetime",
    label: "심폐소생술 중단 시각",
    type: "datetime-local",
  },
  {
    id: "ED_fluid",
    label: "심폐소생술 중 수액 투여량",
    type: "text",
    unit: "ml",
  },
  {
    id: "ED_stop_cause",
    label: "심폐소생술 중단 이유",
    type: "radio",
    options: [
      { label: "ROSC", value: "ROSC" },
      { label: "사망", value: "사망" },
      { label: "DNR", value: "DNR" },
    ],
  },
  {
    id: "Cause_arrest",
    label: "심정지 원인",
    type: "radio",
    options: [
      { label: "내과적, 심장 원인", value: "내과적, 심장 원인" },
      { label: "내과적, 심장 원인이 아님", value: "내과적, 심장 원인이 아님" },
      { label: "Trauma", value: "Trauma" },
      { label: "Asphyxial", value: "Asphyxial" },
      { label: "Drug overdose", value: "Drug overdose" },
      { label: "Drowning", value: "Drowning" },
      { label: "non-Electrocusion", value: "non-Electrocusion" },
      { label: "온열/한랭손상", value: "온열/한랭손상" },
    ],
  },
  {
    id: "Cause_medical",
    label: "심정지 비심인성 원인",
    type: "radio",
    options: [
      { label: "뇌혈관질환", value: "뇌혈관질환" },
      { label: "급성대동맥증후군", value: "급성대동맥증후군" },
      { label: "위장관출혈", value: "위장관출혈" },
      { label: "감염/패혈증", value: "감염/패혈증" },
      { label: "폐색전증", value: "폐색전증" },
      { label: "아나필락시스", value: "아나필락시스" },
      { label: "말기 암", value: "말기 암" },
      {
        label: "전해질 불균형 (Hyperkalemia, Hypokalemia)",
        value: "전해질 불균형 (Hyperkalemia, Hypokalemia)",
      },
      {
        label:
          "기타 (presumed cardiac 에 해당되지 않는 경우, shockable rhythm 보이지 않고 갑자기 쓰러진 모습이 목격되지 않았을 때)",
        value:
          "기타 (presumed cardiac 에 해당되지 않는 경우, shockable rhythm 보이지 않고 갑자기 쓰러진 모습이 목격되지 않았을 때)",
      },
    ],
    conditions: 'Cause_arrest === "내과적, 심장 원인이 아님"',
  },
  {
    id: "Cause_trauma",
    label: "심정지 외상성 원인 (Blunt/Penetrating)",
    type: "radio",
    options: [
      { label: "둔상", value: "둔상" },
      { label: "관통상", value: "관통상" },
      { label: "화상", value: "화상" },
    ],
    conditions: 'Cause_arrest === "Trauma"',
  },
  {
    id: "Cause_asphyxia",
    label: "심정지 질식 원인",
    type: "radio",
    options: [
      { label: "이물질로 인한 기도폐쇄", value: "이물질로 인한 기도폐쇄" },
      { label: "목맴", value: "목맴" },
      { label: "목졸림(교살)", value: "목졸림(교살)" },
    ],
    conditions: 'Cause_arrest === "Asphyxial"',
  },
  {
    id: "ROSC",
    label: "ROSC 여부, 장소 관계 없음",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Not sustained", value: "Not sustained" },
      { label: "Sustained (20분 이상)", value: "Sustained (20분 이상)" },
    ],
  },
  {
    id: "ED_ROSC",
    label: "ROSC, 응급실에서만",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Not sustained", value: "Not sustained" },
      { label: "Sustained (20분 이상)", value: "Sustained (20분 이상)" },
    ],
  },
  {
    id: "ED_nonsust_ROSC_datetime",
    label: "Not sustained ROSC (응급실 내에서, 시각)",
    type: "datetime-local",
  },
  {
    id: "ED_sust_ROSC_datetime",
    label: "Sustained ROSC (응급실 내에서, 시각)",
    type: "datetime-local",
  },
  {
    id: "ROSC1_Re_arrest",
    label: "1st re-arrest 여부",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "ROSC#1 - Re-arrest_datetime",
    label: "1st re-arrest time",
    type: "datetime-local",
    conditions: 'ROSC1_Re_arrest === "예"',
  },
  {
    id: "1st_rearrest_ROSC",
    label: "1st re-arrest ROSC",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Not sustained", value: "Not sustained" },
      { label: "Sustained (20분 이상)", value: "Sustained (20분 이상)" },
    ],
    conditions: 'ROSC1_Re_arrest === "예"',
  },
  {
    id: "1st_rearrest_susROSC_datetime",
    label: "1st re-arrest Sustained ROSC time",
    type: "datetime-local",
    conditions: '1st_rearrest_ROSC === "Sustained (20분 이상)"',
  },
  {
    id: "ROSC2_Re_arrest",
    label: "2nd re-arrest 여부",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "ROSC#2 - Re-arrest_datetime",
    label: "2nd re-arrest time",
    type: "datetime-local",
    conditions: 'ROSC2_Re_arrest === "예"',
  },
  {
    id: "2nd_rearrest_ROSC",
    label: "2nd re-arrest ROSC",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Not sustained", value: "Not sustained" },
      { label: "Sustained (20분 이상)", value: "Sustained (20분 이상)" },
    ],
    conditions: 'ROSC2_Re_arrest === "예"',
  },
  {
    id: "2nd_rearrest_susROSC_datetime",
    label: "2nd re-arrest Sustained ROSC time",
    type: "datetime-local",
    conditions: '2nd_rearrest_ROSC === "Sustained (20분 이상)"',
  },
  {
    id: "ROSC3_Re_arrest",
    label: "3rd re-arrest 여부",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "ROSC#3 - Re-arrest_datetime",
    label: "3rd re-arrest time",
    type: "datetime-local",
    conditions: 'ROSC3_Re_arrest === "예"',
  },
  {
    id: "3rd_rearrest_ROSC",
    label: "3rd re-arrest ROSC",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Not sustained", value: "Not sustained" },
      { label: "Sustained (20분 이상)", value: "Sustained (20분 이상)" },
    ],
    conditions: 'ROSC3_Re_arrest === "예"',
  },
  {
    id: "3rd_rearrest_susROSC_datetime",
    label: "3rd re-arrest Sustained ROSC time",
    type: "datetime-local",
    conditions: '3rd_rearrest_ROSC === "Sustained (20분 이상)"',
  },
  {
    id: "ED_ROSC_ECG",
    label: "ROSC 심전도",
    type: "radio",
    options: [
      { label: "STEMI", value: "STEMI" },
      { label: "ST depression", value: "ST depression" },
      { label: "LBBB", value: "LBBB" },
      { label: "RBBB", value: "RBBB" },
      {
        label: "Non specific ST or T patterns",
        value: "Non specific ST or T patterns",
      },
      {
        label: "Normal ST segment a T wave",
        value: "Normal ST segment a T wave",
      },
      { label: "Prolonged QT", value: "Prolonged QT" },
      { label: "Others", value: "Others" },
    ],
  },
  {
    id: "ED_ROSC_ECG_others",
    label: "ROSC 심전도 (기타)",
    type: "text",
    conditions: 'ED_ROSC_ECG === "Others"',
  },
  {
    id: "ED_disposition",
    label: "결과",
    type: "radio",
    options: [
      { label: "사망", value: "사망" },
      { label: "입원", value: "입원" },
      { label: "Transfer", value: "Transfer" },
      { label: "Hopeless discharge", value: "Hopeless discharge" },
    ],
  },
  {
    id: "Dead",
    label: "사망",
    type: "radio",
    options: [
      { label: "ROSC 없이 사망", value: "ROSC 없이 사망" },
      { label: "Sustained ROSC 없이 사망", value: "Sustained ROSC 없이 사망" },
      {
        label: "Sustained ROSC 되었으나 사망",
        value: "Sustained ROSC 되었으나 사망",
      },
      { label: "DNR로 치료 중단 후 사망", value: "DNR로 치료 중단 후 사망" },
    ],
    conditions: 'ED_disposition === "사망"',
  },
  {
    id: "Admission",
    label: "입원",
    type: "radio",
    options: [
      { label: "ICU 입원", value: "ICU 입원" },
      { label: "Semi ICU 입원", value: "Semi ICU 입원" },
      { label: "일반병실 입원", value: "일반병실 입원" },
    ],
    conditions: 'ED_disposition === "입원"',
  },
  {
    id: "NCV_em",
    label: "NCV 응급용 선별검사",
    type: "radio",
    options: [
      { label: "Positive", value: "Positive" },
      { label: "Negative", value: "Negative" },
      { label: "Indeterminate", value: "Indeterminate" },
      { label: "시행하지않음", value: "시행하지않음" },
    ],
  },
  {
    id: "NCV",
    label: "NCV 정규검사",
    type: "radio",
    options: [
      { label: "Positive", value: "Positive" },
      { label: "Negative", value: "Negative" },
      { label: "Indeterminate", value: "Indeterminate" },
      { label: "시행하지않음", value: "시행하지않음" },
    ],
  },
  {
    id: "admission_memo",
    label: "초진 기록지",
    type: "textarea",
  },
  {
    id: "discharge_memo",
    label: "응급실 퇴실 기록지",
    type: "textarea",
  },

  // 기존 배열에 이어서 계속됨
  {
    id: "DNR",
    label: "DNR 작성여부",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "TTM",
    label: "TTM 시행",
    type: "radio",
    options: [
      { label: "Hypothermia", value: "Hypothermia" },
      { label: "Normothermia", value: "Normothermia" },
      { label: "시행하지 않음", value: "시행하지 않음" },
    ],
  },
  {
    id: "TTM_temp",
    label: "TTM 초기 설정 온도",
    type: "text",
    unit: "℃",
  },
  {
    id: "TTM_reason",
    label: "TTM 미사유",
    type: "radio",
    options: [
      { label: "Obey command", value: "Obey command" },
      { label: "보호자 거부", value: "보호자 거부" },
      { label: "Hopless", value: "Hopless" },
      { label: "Others", value: "Others" },
    ],
  },
  {
    id: "TTM_others_text",
    label: "TTM 미사유 (기타)",
    type: "text",
    conditions: 'TTM_reason === "Others"',
  },
  {
    id: "ECMO",
    label: "CPR 후 ECMO 시행",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "CRRT",
    label: "CRRT시행",
    type: "radio",
    options: [
      { label: "예", value: "예" },
      { label: "아니오", value: "아니오" },
    ],
  },
  {
    id: "Discharge_datetime",
    label: "퇴원시각",
    type: "datetime-local",
  },
  {
    id: "Discharge_Type",
    label: "퇴원형태",
    type: "radio",
    options: [
      { label: "생존퇴원", value: "생존퇴원" },
      { label: "사망퇴원", value: "사망퇴원" },
      { label: "전원", value: "전원" },
      { label: "가망 없는 전원", value: "가망 없는 전원" },
    ],
  },
  {
    id: "Discharge_Note",
    label: "퇴원기록지",
    type: "textarea",
  },
  {
    id: "Discarge_CPC",
    label: "Discarge_CPC",
    type: "radio",
    options: [
      { label: "CPC1", value: "CPC1" },
      { label: "CPC2", value: "CPC2" },
      { label: "CPC3", value: "CPC3" },
      { label: "CPC4", value: "CPC4" },
      { label: "CPC5", value: "CPC5" },
      { label: "기록예정", value: "기록예정" },
    ],
  },
  {
    id: "1month_CPC",
    label: "1month_CPC",
    type: "radio",
    options: [
      { label: "CPC1", value: "CPC1" },
      { label: "CPC2", value: "CPC2" },
      { label: "CPC3", value: "CPC3" },
      { label: "CPC4", value: "CPC4" },
      { label: "CPC5", value: "CPC5" },
      { label: "기록예정", value: "기록예정" },
    ],
  },
  {
    id: "3month_CPC",
    label: "3month_CPC",
    type: "radio",
    options: [
      { label: "CPC1", value: "CPC1" },
      { label: "CPC2", value: "CPC2" },
      { label: "CPC3", value: "CPC3" },
      { label: "CPC4", value: "CPC4" },
      { label: "CPC5", value: "CPC5" },
      { label: "기록예정", value: "기록예정" },
    ],
  },
  {
    id: "6month_CPC",
    label: "6month_CPC",
    type: "radio",
    options: [
      { label: "CPC1", value: "CPC1" },
      { label: "CPC2", value: "CPC2" },
      { label: "CPC3", value: "CPC3" },
      { label: "CPC4", value: "CPC4" },
      { label: "CPC5", value: "CPC5" },
      { label: "기록예정", value: "기록예정" },
    ],
  },
  {
    id: "12month_CPC",
    label: "12month_CPC",
    type: "radio",
    options: [
      { label: "CPC1", value: "CPC1" },
      { label: "CPC2", value: "CPC2" },
      { label: "CPC3", value: "CPC3" },
      { label: "CPC4", value: "CPC4" },
      { label: "CPC5", value: "CPC5" },
      { label: "기록예정", value: "기록예정" },
    ],
  },

  // 기존 배열에 이어서 계속됨
  {
    id: "NSE_Inital_ROSC",
    label: "Initial ROSC 후의 NSE",
    type: "text",
  },
  {
    id: "NSE_24h",
    label: "24시간 후의 NSE",
    type: "text",
  },
  {
    id: "NSE_36h",
    label: "36시간 후의 NSE",
    type: "text",
  },
  {
    id: "NSE_48h",
    label: "48시간 후의 NSE",
    type: "text",
  },
  {
    id: "NSE_72h",
    label: "72시간 후의 NSE",
    type: "text",
  },
  {
    id: "CPR_pupil",
    label: "CPR 중 Pupil",
    type: "radio",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ],
  },
  {
    id: "NPI_Rt_arrest",
    label: "CPR 중 Rt NPI",
    type: "text",
    conditions: 'CPR_pupil === "Yes"',
  },
  {
    id: "NPI_Lt_arrest",
    label: "CPR 중 Lt NPI",
    type: "text",
    conditions: 'CPR_pupil === "Yes"',
  },
  {
    id: "Size_Rt_arrest",
    label: "CPR 중 Rt Size",
    type: "text",
    unit: "mm",
    conditions: 'CPR_pupil === "Yes"',
  },
  {
    id: "Size_Lt_arrest",
    label: "CPR 중 Lt Size",
    type: "text",
    unit: "mm",
    conditions: 'CPR_pupil === "Yes"',
  },
  {
    id: "Min_Rt_arrest",
    label: "CPR 중 Rt Min",
    type: "text",
    unit: "mm",
    conditions: 'CPR_pupil === "Yes"',
  },
  {
    id: "Min_Lt_arrest",
    label: "CPR 중 Lt Min",
    type: "text",
    unit: "mm",
    conditions: 'CPR_pupil === "Yes"',
  },
  {
    id: "Ch_Rt_arrest",
    label: "CPR 중 Rt Ch",
    type: "text",
    unit: "%",
    conditions: 'CPR_pupil === "Yes"',
  },
  {
    id: "Ch_Lt_arrest",
    label: "CPR 중 Lt Ch",
    type: "text",
    unit: "%",
    conditions: 'CPR_pupil === "Yes"',
  },
  {
    id: "CV_Rt_arrest",
    label: "CPR 중 Rt CV",
    type: "text",
    unit: "mm/s",
    conditions: 'CPR_pupil === "Yes"',
  },
  {
    id: "CV_Lt_arrest",
    label: "CPR 중 Lt CV",
    type: "text",
    unit: "mm/s",
    conditions: 'CPR_pupil === "Yes"',
  },
  {
    id: "LAT_Rt_arrest",
    label: "CPR 중 Rt LAT",
    type: "text",
    unit: "sec",
    conditions: 'CPR_pupil === "Yes"',
  },
  {
    id: "LAT_Lt_arrest",
    label: "CPR 중 Lt LAT",
    type: "text",
    unit: "sec",
    conditions: 'CPR_pupil === "Yes"',
  },
  {
    id: "DV_Rt_arrest",
    label: "CPR 중 Rt DV",
    type: "text",
    unit: "mm/s",
    conditions: 'CPR_pupil === "Yes"',
  },
  {
    id: "DV_Lt_arrest",
    label: "CPR 중 Lt DV",
    type: "text",
    unit: "mm/s",
    conditions: 'CPR_pupil === "Yes"',
  },
  {
    id: "ROSC_pupil",
    label: "ROSC 직후 Pupil",
    type: "radio",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ],
  },
  {
    id: "NPI_Rt_ROSC",
    label: "ROSC 직후 Rt NPI",
    type: "text",
    conditions: 'ROSC_pupil === "Yes"',
  },
  {
    id: "NPI_Lt_ROSC",
    label: "ROSC 직후 Lt NPI",
    type: "text",
    conditions: 'ROSC_pupil === "Yes"',
  },
  {
    id: "Size_Rt_ROSC",
    label: "ROSC 직후 Rt Size",
    type: "text",
    unit: "mm",
    conditions: 'ROSC_pupil === "Yes"',
  },
  {
    id: "Size_Lt_ROSC",
    label: "ROSC 직후 Lt Size",
    type: "text",
    unit: "mm",
    conditions: 'ROSC_pupil === "Yes"',
  },
  {
    id: "Min_Rt_ROSC",
    label: "ROSC 직후 Rt Min",
    type: "text",
    unit: "mm",
    conditions: 'ROSC_pupil === "Yes"',
  },
  {
    id: "Min_Lt_ROSC",
    label: "ROSC 직후 Lt Min",
    type: "text",
    unit: "mm",
    conditions: 'ROSC_pupil === "Yes"',
  },
  {
    id: "Ch_Rt_ROSC",
    label: "ROSC 직후 Rt Ch",
    type: "text",
    unit: "%",
    conditions: 'ROSC_pupil === "Yes"',
  },
  {
    id: "Ch_Lt_ROSC",
    label: "ROSC 직후 Lt Ch",
    type: "text",
    unit: "%",
    conditions: 'ROSC_pupil === "Yes"',
  },
  {
    id: "CV_Rt_ROSC",
    label: "ROSC 직후 Rt CV",
    type: "text",
    unit: "mm/s",
    conditions: 'ROSC_pupil === "Yes"',
  },
  {
    id: "CV_Lt_ROSC",
    label: "ROSC 직후 Lt CV",
    type: "text",
    unit: "mm/s",
    conditions: 'ROSC_pupil === "Yes"',
  },
  {
    id: "MCV_Rt_ROSC",
    label: "ROSC 직후 Rt MCV",
    type: "text",
    unit: "mm/s",
    conditions: 'ROSC_pupil === "Yes"',
  },
  {
    id: "MCV_Lt_ROSC",
    label: "ROSC 직후 Lt MCV",
    type: "text",
    unit: "mm/s",
    conditions: 'ROSC_pupil === "Yes"',
  },
  {
    id: "LAT_Rt_ROSC",
    label: "ROSC 직후 Rt LAT",
    type: "text",
    unit: "sec",
    conditions: 'ROSC_pupil === "Yes"',
  },
  {
    id: "LAT_Lt_ROSC",
    label: "ROSC 직후 Lt LAT",
    type: "text",
    unit: "sec",
    conditions: 'ROSC_pupil === "Yes"',
  },
  {
    id: "DV_Rt_ROSC",
    label: "ROSC 직후 Rt DV",
    type: "text",
    unit: "mm/s",
    conditions: 'ROSC_pupil === "Yes"',
  },
  {
    id: "DV_Lt_ROSC",
    label: "ROSC 직후 Lt DV",
    type: "text",
    unit: "mm/s",
    conditions: 'ROSC_pupil === "Yes"',
  },
  {
    id: "12th_pupil",
    label: "12시간 직후 Pupil",
    type: "radio",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ],
  },
  {
    id: "NPI_Rt_12hrs",
    label: "12시간 이후 Rt NPI",
    type: "text",
    conditions: '12th_pupil === "Yes"',
  },
  {
    id: "NPI_Lt_12hrs",
    label: "12시간 이후 Lt NPI",
    type: "text",
    conditions: '12th_pupil === "Yes"',
  },
  {
    id: "Size_Rt_12hrs",
    label: "12시간 이후 Rt Size",
    type: "text",
    unit: "mm",
    conditions: '12th_pupil === "Yes"',
  },
  {
    id: "Size_Lt_12hrs",
    label: "12시간 이후 Lt Size",
    type: "text",
    unit: "mm",
    conditions: '12th_pupil === "Yes"',
  },
  {
    id: "Min_Rt_12hrs",
    label: "12시간 이후 Rt Min",
    type: "text",
    unit: "mm",
    conditions: '12th_pupil === "Yes"',
  },
  {
    id: "Min_Lt_12hrs",
    label: "12시간 이후 Lt Min",
    type: "text",
    unit: "mm",
    conditions: '12th_pupil === "Yes"',
  },
  {
    id: "Ch_Rt_12hrs",
    label: "12시간 이후 Rt Ch",
    type: "text",
    unit: "%",
    conditions: '12th_pupil === "Yes"',
  },
  {
    id: "Ch_Lt_12hrs",
    label: "12시간 이후 Lt Ch",
    type: "text",
    unit: "%",
    conditions: '12th_pupil === "Yes"',
  },
  {
    id: "CV_Rt_12hrs",
    label: "12시간 이후 Rt CV",
    type: "text",
    unit: "mm/s",
    conditions: '12th_pupil === "Yes"',
  },
  {
    id: "CV_Lt_12hrs",
    label: "12시간 이후 Lt CV",
    type: "text",
    unit: "mm/s",
    conditions: '12th_pupil === "Yes"',
  },
  {
    id: "MCV_Rt_12hrs",
    label: "12시간 이후 Rt MCV",
    type: "text",
    unit: "mm/s",
    conditions: '12th_pupil === "Yes"',
  },
  {
    id: "MCV_Lt_12hrs",
    label: "12시간 이후 Lt MCV",
    type: "text",
    unit: "mm/s",
    conditions: '12th_pupil === "Yes"',
  },
  {
    id: "LAT_Rt_12hrs",
    label: "12시간 이후 Rt LAT",
    type: "text",
    unit: "sec",
    conditions: '12th_pupil === "Yes"',
  },
  {
    id: "LAT_Lt_12hrs",
    label: "12시간 이후 Lt LAT",
    type: "text",
    unit: "sec",
    conditions: '12th_pupil === "Yes"',
  },
  {
    id: "DV_Rt_12hrs",
    label: "12시간 이후 Rt DV",
    type: "text",
    unit: "mm/s",
    conditions: '12th_pupil === "Yes"',
  },
  {
    id: "DV_Lt_12hrs",
    label: "12시간 이후 Lt DV",
    type: "text",
    unit: "mm/s",
    conditions: '12th_pupil === "Yes"',
  },
  {
    id: "24th_pupil",
    label: "24시간 직후 Pupil",
    type: "radio",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ],
  },
  {
    id: "NPI_Rt_24hrs",
    label: "24시간 이후 Rt NPI",
    type: "text",
    conditions: '24th_pupil === "Yes"',
  },
  {
    id: "NPI_Lt_24hrs",
    label: "24시간 이후 Lt NPI",
    type: "text",
    conditions: '24th_pupil === "Yes"',
  },
  {
    id: "Size_Rt_24hrs",
    label: "24시간 이후 Rt Size",
    type: "text",
    unit: "mm",
    conditions: '24th_pupil === "Yes"',
  },
  {
    id: "Size_Lt_24hrs",
    label: "24시간 이후 Lt Size",
    type: "text",
    unit: "mm",
    conditions: '24th_pupil === "Yes"',
  },
  {
    id: "Min_Rt_24hrs",
    label: "24시간 이후 Rt Min",
    type: "text",
    unit: "mm",
    conditions: '24th_pupil === "Yes"',
  },
  {
    id: "Min_Lt_24hrs",
    label: "24시간 이후 Lt Min",
    type: "text",
    unit: "mm",
    conditions: '24th_pupil === "Yes"',
  },
  {
    id: "Ch_Rt_24hrs",
    label: "24시간 이후 Rt Ch",
    type: "text",
    unit: "%",
    conditions: '24th_pupil === "Yes"',
  },
  {
    id: "Ch_Lt_24hrs",
    label: "24시간 이후 Lt Ch",
    type: "text",
    unit: "%",
    conditions: '24th_pupil === "Yes"',
  },
  {
    id: "CV_Rt_24hrs",
    label: "24시간 이후 Rt CV",
    type: "text",
    unit: "mm/s",
    conditions: '24th_pupil === "Yes"',
  },
  {
    id: "CV_Lt_24hrs",
    label: "24시간 이후 Lt CV",
    type: "text",
    unit: "mm/s",
    conditions: '24th_pupil === "Yes"',
  },
  {
    id: "MCV_Rt_24hrs",
    label: "24시간 이후 Rt MCV",
    type: "text",
    unit: "mm/s",
    conditions: '24th_pupil === "Yes"',
  },
  {
    id: "MCV_Lt_24hrs",
    label: "24시간 이후 Lt MCV",
    type: "text",
    unit: "mm/s",
    conditions: '24th_pupil === "Yes"',
  },
  {
    id: "LAT_Rt_24hrs",
    label: "24시간 이후 Rt LAT",
    type: "text",
    unit: "sec",
    conditions: '24th_pupil === "Yes"',
  },
  {
    id: "LAT_Lt_24hrs",
    label: "24시간 이후 Lt LAT",
    type: "text",
    unit: "sec",
    conditions: '24th_pupil === "Yes"',
  },
  {
    id: "DV_Rt_24hrs",
    label: "24시간 이후 Rt DV",
    type: "text",
    unit: "mm/s",
    conditions: '24th_pupil === "Yes"',
  },
  {
    id: "DV_Lt_24hrs",
    label: "24시간 이후 Lt DV",
    type: "text",
    unit: "mm/s",
    conditions: '24th_pupil === "Yes"',
  },
  {
    id: "36th_pupil",
    label: "36시간 직후 Pupil",
    type: "radio",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ],
  },
  {
    id: "NPI_Rt_36hrs",
    label: "36시간 이후 Rt NPI",
    type: "text",
    conditions: '36th_pupil === "Yes"',
  },
  {
    id: "NPI_Lt_36hrs",
    label: "36시간 이후 Lt NPI",
    type: "text",
    conditions: '36th_pupil === "Yes"',
  },
  {
    id: "Size_Rt_36hrs",
    label: "36시간 이후 Rt Size",
    type: "text",
    unit: "mm",
    conditions: '36th_pupil === "Yes"',
  },
  {
    id: "Size_Lt_36hrs",
    label: "36시간 이후 Lt Size",
    type: "text",
    unit: "mm",
    conditions: '36th_pupil === "Yes"',
  },
  {
    id: "Min_Rt_36hrs",
    label: "36시간 이후 Rt Min",
    type: "text",
    unit: "mm",
    conditions: '36th_pupil === "Yes"',
  },
  {
    id: "Min_Lt_36hrs",
    label: "36시간 이후 Lt Min",
    type: "text",
    unit: "mm",
    conditions: '36th_pupil === "Yes"',
  },
  {
    id: "Ch_Rt_36hrs",
    label: "36시간 이후 Rt Ch",
    type: "text",
    unit: "%",
    conditions: '36th_pupil === "Yes"',
  },
  {
    id: "Ch_Lt_36hrs",
    label: "36시간 이후 Lt Ch",
    type: "text",
    unit: "%",
    conditions: '36th_pupil === "Yes"',
  },
  {
    id: "CV_Rt_36hrs",
    label: "36시간 이후 Rt CV",
    type: "text",
    unit: "mm/s",
    conditions: '36th_pupil === "Yes"',
  },
  {
    id: "CV_Lt_36hrs",
    label: "36시간 이후 Lt CV",
    type: "text",
    unit: "mm/s",
    conditions: '36th_pupil === "Yes"',
  },
  {
    id: "MCV_Rt_36hrs",
    label: "36시간 이후 Rt MCV",
    type: "text",
    unit: "mm/s",
    conditions: '36th_pupil === "Yes"',
  },
  {
    id: "MCV_Lt_36hrs",
    label: "36시간 이후 Lt MCV",
    type: "text",
    unit: "mm/s",
    conditions: '36th_pupil === "Yes"',
  },
  {
    id: "LAT_Rt_36hrs",
    label: "36시간 이후 Rt LAT",
    type: "text",
    unit: "sec",
    conditions: '36th_pupil === "Yes"',
  },
  {
    id: "LAT_Lt_36hrs",
    label: "36시간 이후 Lt LAT",
    type: "text",
    unit: "sec",
    conditions: '36th_pupil === "Yes"',
  },
  {
    id: "DV_Rt_36hrs",
    label: "36시간 이후 Rt DV",
    type: "text",
    unit: "mm/s",
    conditions: '36th_pupil === "Yes"',
  },
  {
    id: "DV_Lt_36hrs",
    label: "36시간 이후 Lt DV",
    type: "text",
    unit: "mm/s",
    conditions: '36th_pupil === "Yes"',
  },
  {
    id: "48th_pupil",
    label: "48시간 직후 Pupil",
    type: "radio",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ],
  },
  {
    id: "NPI_Rt_48hrs",
    label: "48시간 이후 Rt NPI",
    type: "text",
    conditions: '48th_pupil === "Yes"',
  },
  {
    id: "NPI_Lt_48hrs",
    label: "48시간 이후 Lt NPI",
    type: "text",
    conditions: '48th_pupil === "Yes"',
  },
  {
    id: "Size_Rt_48hrs",
    label: "48시간 이후 Rt Size",
    type: "text",
    unit: "mm",
    conditions: '48th_pupil === "Yes"',
  },
  {
    id: "Size_Lt_48hrs",
    label: "48시간 이후 Lt Size",
    type: "text",
    unit: "mm",
    conditions: '48th_pupil === "Yes"',
  },
  {
    id: "Min_Rt_48hrs",
    label: "48시간 이후 Rt Min",
    type: "text",
    unit: "mm",
    conditions: '48th_pupil === "Yes"',
  },
  {
    id: "Min_Lt_48hrs",
    label: "48시간 이후 Lt Min",
    type: "text",
    unit: "mm",
    conditions: '48th_pupil === "Yes"',
  },
  {
    id: "Ch_Rt_48hrs",
    label: "48시간 이후 Rt Ch",
    type: "text",
    unit: "%",
    conditions: '48th_pupil === "Yes"',
  },
  {
    id: "Ch_Lt_48hrs",
    label: "48시간 이후 Lt Ch",
    type: "text",
    unit: "%",
    conditions: '48th_pupil === "Yes"',
  },
  {
    id: "CV_Rt_48hrs",
    label: "48시간 이후 Rt CV",
    type: "text",
    unit: "mm/s",
    conditions: '48th_pupil === "Yes"',
  },
  {
    id: "CV_Lt_48hrs",
    label: "48시간 이후 Lt CV",
    type: "text",
    unit: "mm/s",
    conditions: '48th_pupil === "Yes"',
  },
  {
    id: "MCV_Rt_48hrs",
    label: "48시간 이후 Rt MCV",
    type: "text",
    unit: "mm/s",
    conditions: '48th_pupil === "Yes"',
  },
  {
    id: "MCV_Lt_48hrs",
    label: "48시간 이후 Lt MCV",
    type: "text",
    unit: "mm/s",
    conditions: '48th_pupil === "Yes"',
  },
  {
    id: "LAT_Rt_48hrs",
    label: "48시간 이후 Rt LAT",
    type: "text",
    unit: "sec",
    conditions: '48th_pupil === "Yes"',
  },
  {
    id: "LAT_Lt_48hrs",
    label: "48시간 이후 Lt LAT",
    type: "text",
    unit: "sec",
    conditions: '48th_pupil === "Yes"',
  },
  {
    id: "DV_Rt_48hrs",
    label: "48시간 이후 Rt DV",
    type: "text",
    unit: "mm/s",
    conditions: '48th_pupil === "Yes"',
  },
  {
    id: "DV_Lt_48hrs",
    label: "48시간 이후 Lt DV",
    type: "text",
    unit: "mm/s",
    conditions: '48th_pupil === "Yes"',
  },
  {
    id: "72th_pupil",
    label: "72시간 직후 Pupil",
    type: "radio",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ],
  },
  {
    id: "NPI_Rt_72hrs",
    label: "72시간 이후 Rt NPI",
    type: "text",
    conditions: '72th_pupil === "Yes"',
  },
  {
    id: "NPI_Lt_72hrs",
    label: "72시간 이후 Lt NPI",
    type: "text",
    conditions: '72th_pupil === "Yes"',
  },
  {
    id: "Size_Rt_72hrs",
    label: "72시간 이후 Rt Size",
    type: "text",
    unit: "mm",
    conditions: '72th_pupil === "Yes"',
  },
  {
    id: "Size_Lt_72hrs",
    label: "72시간 이후 Lt Size",
    type: "text",
    unit: "mm",
    conditions: '72th_pupil === "Yes"',
  },
  {
    id: "Min_Rt_72hrs",
    label: "72시간 이후 Rt Min",
    type: "text",
    unit: "mm",
    conditions: '72th_pupil === "Yes"',
  },
  {
    id: "Min_Lt_72hrs",
    label: "72시간 이후 Lt Min",
    type: "text",
    unit: "mm",
    conditions: '72th_pupil === "Yes"',
  },
  {
    id: "Ch_Rt_72hrs",
    label: "72시간 이후 Rt Ch",
    type: "text",
    unit: "%",
    conditions: '72th_pupil === "Yes"',
  },
  {
    id: "Ch_Lt_72hrs",
    label: "72시간 이후 Lt Ch",
    type: "text",
    unit: "%",
    conditions: '72th_pupil === "Yes"',
  },
  {
    id: "CV_Rt_72hrs",
    label: "72시간 이후 Rt CV",
    type: "text",
    unit: "mm/s",
    conditions: '72th_pupil === "Yes"',
  },
  {
    id: "CV_Lt_72hrs",
    label: "72시간 이후 Lt CV",
    type: "text",
    unit: "mm/s",
    conditions: '72th_pupil === "Yes"',
  },
  {
    id: "MCV_Rt_72hrs",
    label: "72시간 이후 Rt MCV",
    type: "text",
    unit: "mm/s",
    conditions: '72th_pupil === "Yes"',
  },
  {
    id: "MCV_Lt_72hrs",
    label: "72시간 이후 Lt MCV",
    type: "text",
    unit: "mm/s",
    conditions: '72th_pupil === "Yes"',
  },
  {
    id: "LAT_Rt_72hrs",
    label: "72시간 이후 Rt LAT",
    type: "text",
    unit: "sec",
    conditions: '72th_pupil === "Yes"',
  },
  {
    id: "LAT_Lt_72hrs",
    label: "72시간 이후 Lt LAT",
    type: "text",
    unit: "sec",
    conditions: '72th_pupil === "Yes"',
  },
  {
    id: "DV_Rt_72hrs",
    label: "72시간 이후 Rt DV",
    type: "text",
    unit: "mm/s",
    conditions: '72th_pupil === "Yes"',
  },
  {
    id: "DV_Lt_72hrs",
    label: "72시간 이후 Lt DV",
    type: "text",
    unit: "mm/s",
    conditions: '72th_pupil === "Yes"',
  },

  {
    id: "response_time",
    label: "Response Time",
    type: "text",
    readOnly: true,
    conditions:
      "EMS_call_time과 EMS_arrive_time이 모두 입력된 경우, 두 시간의 차이(분)를 계산. 차이가 음수이거나 120분을 초과하면 오류 메시지 표시: '시간데이터 오류! : EMS 신고 시각이 EMS 도착 시각보다 나중이거나 2시간 이상 차이'",
  },
  {
    id: "scene_time",
    label: "Scene time interval",
    type: "text",
    readOnly: true,
    conditions:
      "EMS_arrive_time과 EMS_Departure_time이 모두 입력된 경우, 두 시간의 차이(분)를 계산. 차이가 음수이거나 120분을 초과하면 오류 메시지 표시: '시간데이터 오류! : EMS departure가 EMS arrival보다 먼저이거나 2시간 이상 차이'",
  },
  {
    id: "transport_time",
    label: "Transport Time",
    type: "text",
    readOnly: true,
    conditions:
      "EMS_Departure_time과 ED_arrival_time_two가 모두 입력된 경우, 두 시간의 차이(분)를 계산. 차이가 음수이거나 180분을 초과하면 오류 메시지 표시: '시간데이터 오류! : ED 도착 시각이 EMS 출발 시각보다 먼저이거나 3시간 이상 차이'",
  },
];

/* ── 파생 데이터 (기존 코드 호환) ─────────────────────────────── */
export const formFieldMap = Object.fromEntries(
  formFieldDefs.map((f) => [f.id, f]),
);
